<template>
    <div class="body-panel">
        <div class="body-panel-content">
            <div class="body-panel-content-start flex">
                <div class="login-page-bg">
                </div>
                <div class="login-page">
                    <div class="login-logo" v-if="info.StartImage != null">
                        <img class="login-logo-img" :src="info.StartImage" />
                    </div>
                    <div class="login" v-if="result != null">
                        <!-- Email подтверждён -->
                        <div v-if="status === 2">
                            <div class="form-header">
                                Ваш email успешно подтверждён!
                            </div>
                            <div class="auth-content-block">
                                Теперь вы можете авторизоваться, используя свои данные для входа.
                            </div>
                            <!-- Кнопка для перехода на страницу логина -->
                            <div class="form-actions form-btns">
                                <router-link to="/login">
                                    <button type="button" class="btn btn-primary">
                                        Авторизация
                                    </button>
                                </router-link>
                            </div>
                        </div>

                        <!-- Сообщение после регистрации (если статус не подтвержден) -->
                        <div v-else>
                            <div class="form-header">
                                Спасибо за регистрацию!
                            </div>
                            <div class="auth-content-block">
                                В ближайшее время ваши данные проверит Администратор, после чего вы получите уведомление на email и сможете авторизоваться.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vue-headful title="Подтверждение email" />
    </div>
</template>

<script>
  import UI from '../helpers/ui-helpers'
  import BackendApi from '../backendApi'

  let backendApi = new BackendApi();

  export default {
      name: "confirm-email",

      props: ['info'],

      data(){
          return{
              result: null,
              status: null
          }
      },

      mounted() {
          let vm = this;

          let hash = vm.$route.params.hash;
          if(!hash){
              vm.$router.push('/login');
          }

          backendApi.userConfirmEmail(hash).then(function (response) {
              console.info('reset -> backendApi.userConfirmEmail, response:', response);
              if (response.hasError) {
                  if(response.status === 1404){
                      // неверный hash
                      console.info('неверный hash');
                      vm.$router.push('/login');
                  }
                  else{
                      UI.toastr.error('Ошибка при загрузке страницы');
                  }
              }
              else {
                if (response.data != null) {
                  vm.status = response.data
                    }
                  vm.result = true;
              }
          });
      }

  }
</script>

<style scoped="">

</style>


// WEBPACK FOOTER //
// Content/src/views/UserConfirm.vue